import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _regeneratorRuntime from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.array.flat-map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find-index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { snakeCase } from 'lodash';
import Vue from 'vue';
import VuePluralize from 'vue-pluralize';
import { groupArrayOfObjects, removeHtmlTags, removeRedundantCharacters } from "../../common/helpers";
Vue.use(VuePluralize);

/**
 * API request - get n-grams.
 *
 * Payload:
 * - concept
 * - content
 * - params
 * - clear
 *
 * @param dispatch
 * @param commit
 * @param getters
 * @param payload
 * @returns {*}
 */
export function getNGrams(_ref, payload) {
  var dispatch = _ref.dispatch,
    commit = _ref.commit,
    getters = _ref.getters;
  var urlPrefix = payload.content === 'query' ? '' : payload.content + '-';
  var url = urlPrefix + payload.concept + '-n-grams';
  return dispatch('api', {
    url: url,
    params: _objectSpread({}, payload.params),
    wait: 'n-grams'
  }, {
    root: true
  }).then(function (response) {
    // Add wuis property because reactivity
    var data = response.data.data.map(function (n) {
      n.wuis = [];
      n.cuis = [];
      return n;
    });
    commit('SET_ARRAY', {
      state: 'nGrams',
      data: data
    });
    commit('SET', {
      state: 'nGramsMeta',
      data: response.data.meta
    });
    commit('SET', {
      state: 'concept',
      data: payload.concept
    });
    commit('SET', {
      state: 'content',
      data: payload.content
    });
    return Promise.resolve(response);
  });
}

/**
 * Get n-gram progresses.
 * @param dispatch
 * @param commit
 * @param getters
 * @param {Array} nGrams
 * @param {Number} priority
 * @returns {*}
 */
export function getNGramProgresses(_ref2, _ref3) {
  var dispatch = _ref2.dispatch,
    commit = _ref2.commit,
    getters = _ref2.getters;
  var nGrams = _ref3.nGrams,
    priority = _ref3.priority;
  var urlPrefix = getters.content === 'query' ? '' : getters.content + '-';
  var url = urlPrefix + getters.concept + '-n-grams/progress';
  var params = {
    n_grams: nGrams
  };
  if (priority) {
    params.priority = priority;
  }
  return dispatch('api', {
    url: url,
    params: params
  }, {
    root: true
  }).then(function (response) {
    commit('UPDATE_NGRAM_PROGRESSES', response.data.data);
  });
}

/**
 * Get wuis or cuis related to an n-gram.
 *
 * Payload:
 * - id
 *
 * @param dispatch
 * @param commit
 * @param getters
 * @param {Object} payload
 * @param {number} payload.id - NGram id
 * @param {string} payload.itemsKey - cuis or wuis
 * @param {boolean} payload.updateContent - Should it update cuis or wuis
 * @returns {*}
 */
export function getConceptNGram(_ref4, payload) {
  var dispatch = _ref4.dispatch,
    commit = _ref4.commit,
    getters = _ref4.getters;
  var urlPrefix = getters.content === 'query' ? '' : getters.content + '-';
  var url = urlPrefix + getters.concept + '-n-grams';
  var params = {
    include: 'user'
  };

  // Set priority param on Wui Reddit...
  if (getters.concept === 'wui' && getters.content === 'reddit') {
    params.priority = 1;
  }
  return dispatch('api', {
    url: url + '/' + payload.id,
    params: params
  }, {
    root: true
  }).then(function (response) {
    commit('UPDATE_NGRAM', {
      itemsKey: payload.itemsKey,
      data: response.data.data,
      updateContent: !!payload.updateContent
    });

    // Unfreeze the panel
    var data = response.data.data;
    var items = data[getters.concept + 's'];
    var item = items.find(function (i) {
      return i.id === getters.selectedConcept.id;
    });
    if (item && item.progress_completed === item.progress_total) {
      dispatch('unfreezePanel');
    }
  });
}
export function freezePanel(_ref5) {
  var commit = _ref5.commit,
    state = _ref5.state;
  commit('FREEZE_PANEL', state.selectedConcept);
}
export function unfreezePanel(_ref6) {
  var commit = _ref6.commit,
    state = _ref6.state;
  commit('UNFREEZE_PANEL', state.selectedConcept);
}
export function updateNGramItemState(_ref7, payload) {
  var commit = _ref7.commit;
  commit('UPDATE_NGRAM_ITEM_STATE', payload);
}
export function toggleNGramSelection(_ref8, payload) {
  var commit = _ref8.commit;
  return commit('TOGGLE_ARRAY', {
    state: 'nGramsSelection',
    data: payload,
    key: 'id'
  });
}
export function toggleCuiSelection(_ref9, payload) {
  var commit = _ref9.commit;
  return commit('TOGGLE_ARRAY', {
    state: 'cuisSelection',
    data: payload,
    key: 'id'
  });
}
export function toggleQuerySelection(_ref10, payload) {
  var commit = _ref10.commit;
  return commit('TOGGLE_ARRAY', {
    state: 'queriesSelection',
    data: payload,
    key: 'id'
  });
}

/**
 * Assign one or more N-grams to an user.
 *
 * @param dispatch
 * @param commit
 * @param getters
 * @returns {*}
 */
export function assign(_ref11) {
  var dispatch = _ref11.dispatch,
    commit = _ref11.commit,
    getters = _ref11.getters;
  var urlPrefix = getters.content === 'query' ? '' : getters.content + '-';
  var url = urlPrefix + getters.concept + '-n-grams/assign';
  return dispatch('api', {
    method: 'put',
    url: url,
    data: {
      n_grams: getters.nGramsSelection.map(function (o) {
        return o.id;
      }).join(',')
    },
    wait: 'n-grams-assign'
  }, {
    root: true
  }).then(function (response) {
    commit('ASSIGN_N_GRAMS', response.data.data);
    commit('SET_ARRAY', {
      state: 'nGramsSelection',
      data: []
    });
  });
}

/**
 * Assign N-gram to an user by admin.
 *
 * Payload:
 * - user_id
 * - nGrams
 *
 * @param dispatch
 * @param commit
 * @param getters
 * @param payload
 * @returns {*}
 */
export function assignTo(_ref12, payload) {
  var dispatch = _ref12.dispatch,
    commit = _ref12.commit,
    getters = _ref12.getters;
  var urlPrefix = getters.content === 'query' ? '' : getters.content + '-';
  var url = urlPrefix + getters.concept + '-n-grams/assign/';
  return dispatch('api', {
    method: 'put',
    url: url + payload.user_id,
    data: {
      n_grams: payload.nGrams.join(',')
    },
    wait: 'n-grams-assign'
  }, {
    root: true
  }).then(function (response) {
    commit('ASSIGN_N_GRAMS', response.data.data);
    commit('SET_ARRAY', {
      state: 'nGramsSelection',
      data: []
    });
  });
}

/**
 * Unassign one or more N-grams from a user.
 *
 * Payload:
 * - nGrams
 *
 * @param dispatch
 * @param commit
 * @param getters
 * @param payload
 * @returns {*}
 */
export function unassign(_ref13) {
  var dispatch = _ref13.dispatch,
    commit = _ref13.commit,
    getters = _ref13.getters;
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var urlPrefix = getters.content === 'query' ? '' : getters.content + '-';
  var url = urlPrefix + getters.concept + '-n-grams/unassign';
  var nGrams = payload.nGrams ? payload.nGrams : getters.nGramsSelection.map(function (n) {
    return n.id;
  });
  return dispatch('api', {
    method: 'put',
    url: url,
    data: {
      n_grams: nGrams.join(',')
    },
    wait: 'n-grams-unassign'
  }, {
    root: true
  }).then(function (response) {
    commit('UNASSIGN_N_GRAMS', response.data.data);
    commit('SET_ARRAY', {
      state: 'nGramsSelection',
      data: []
    });
  });
}

/**
 * Get details for CUI or WUI by given id.
 *
 * Payload:
 * - id
 *
 * @param dispatch
 * @param getters
 * @param commit
 * @param payload
 * @returns {*}
 */
export function getConceptDetails(_ref14, payload) {
  var dispatch = _ref14.dispatch,
    getters = _ref14.getters,
    commit = _ref14.commit;
  var params = {
    resource: getters.concept + 's',
    id: payload.id,
    state: getters.concept
  };
  return dispatch('conceptEntities/getEntityDetails', params, {
    root: true
  }).then(function (response) {
    commit('ADD_CONCEPT_DETAILS', response.data);
  });
}

/**
 * Get HTML section for Wiki/MedlinePlus CUI item.
 *
 * @param dispatch
 * @param model
 * @param id
 * @returns {*}
 */
export function getSectionContent(_ref15, _ref16) {
  var dispatch = _ref15.dispatch;
  var model = _ref16.model,
    id = _ref16.id;
  var url = "content-assembler/".concat(model, "/").concat(id, "/expand");
  return dispatch('api', {
    url: url,
    wait: 'wiki-details'
  }, {
    root: true
  }).then(function (_ref17) {
    var data = _ref17.data.data;
    return data;
  });
}

/**
 * Get HTML article for Wiki/MedlinePlus CUI item.
 *
 * @param dispatch
 * @param model
 * @param id
 * @returns {*}
 */
export function getArticleContent(_ref18, _ref19) {
  var dispatch = _ref18.dispatch;
  var model = _ref19.model,
    id = _ref19.id;
  var url = "content-assembler/".concat(model, "/").concat(id);
  return dispatch('api', {
    url: url,
    wait: 'wiki-details'
  }, {
    root: true
  }).then(function (_ref20) {
    var data = _ref20.data.data;
    return data;
  });
}

/**
 * Select a concept.
 *
 * @param commit
 * @param payload
 * @returns {*}
 */
export function setSelectedConcept(_ref21, payload) {
  var commit = _ref21.commit;
  return commit('SET_SELECTED_CONCEPT', payload);
}

/**
 * Get content (queries, reddits...) for the right panel when user select a concept.
 *
 * Payload:
 * - url
 * - params
 * - commitAfter
 *
 * @param dispatch
 * @param getters
 * @param payload
 * @param commit
 * @returns {*}
 */
export function getQueries(_ref22, payload) {
  var dispatch = _ref22.dispatch,
    commit = _ref22.commit;
  return dispatch('api', {
    url: payload.url,
    params: _objectSpread({}, payload.params),
    cancelToken: payload.cancelToken,
    wait: 'get-queries'
  }, {
    root: true
  }).then(function (_ref23) {
    var data = _ref23.data;
    // Return data if we have some action in progress or on Select max...
    if (data.in_progress === 1 || payload.params.return === 'all') {
      return data;
    } else if (payload.model) {
      data.data.map(function (e) {
        var item = e[payload.model];
        var rawTerm = item.name.slice(e.start_position, e.end_position);

        // Remove redundant characters |# and <mark>
        item.highlightTerm = removeRedundantCharacters(rawTerm);
        var markedSentence = item.name.slice(0, e.start_position) + '<ins class="text__highlight--positioned">' + rawTerm + '</ins>' + item.name.slice(e.end_position, item.name.length);

        // Remove redundant characters |# and <mark>
        item.name = removeRedundantCharacters(markedSentence);
        // Remove redundant characters and html tags from article title
        item.article_title = removeHtmlTags(item.article_title);
        return e;
      });
    }
    commit('SET_CONCEPT_QUERIES', data);
  }).catch(function (error) {
    // Catch error which does not refer to request cancellation
    if (!error.message) {
      throw new Error('An error occurred on API request. ' + error);
    }
  });
}

/**
 * @param commit
 * @param index
 * @returns {*}
 */
export function onExpandToggle(_ref24, index) {
  var commit = _ref24.commit;
  return commit('TOGGLE_EXPANDED', index);
}

/**
 * @param commit
 * @param index
 * @returns {*}
 */
export function onExpandConceptQueriesToggle(_ref25, index) {
  var commit = _ref25.commit;
  return commit('TOGGLE_EXPANDED_CONCEPT_QUERIES', index);
}

/**
 * @param commit
 * @returns {*}
 */
export function clearExpanded(_ref26) {
  var commit = _ref26.commit;
  return commit('CLEAR_EXPANDED');
}

/**
 * @param commit
 * @returns {*}
 */
export function clearExpandedConceptQueries(_ref27) {
  var commit = _ref27.commit;
  return commit('CLEAR_EXPANDED_CONCEPT_QUERIES');
}

/**
 * @param commit
 * @returns {*}
 */
export function toggleMeshPanel(_ref28) {
  var commit = _ref28.commit;
  return commit('TOGGLE_MESH_PANEL');
}

/**
 * @param commit
 * @param payload
 * @returns {*}
 */
export function toggleAllQueries(_ref29, payload) {
  var commit = _ref29.commit;
  return commit('SET', {
    state: 'queriesSelection',
    data: payload
  });
}

/**
 * Send API request for Linking MeSH and CUIs.
 *
 * @param dispatch
 * @param commit
 * @param getters
 * @param rootGetters
 * @param payload
 * @returns {*}
 */
export function applyMeshLinkAction(_ref30) {
  var dispatch = _ref30.dispatch,
    commit = _ref30.commit,
    getters = _ref30.getters,
    rootGetters = _ref30.rootGetters;
  var action = rootGetters['conceptActions/actionByName']('mesh-link');
  var selectedCuisCodes = getters.cuisSelection.map(function (c) {
    return c.code;
  });
  var selectedMesh = getters['meshes/selectedMesh'];
  var meshCuiData = {
    mesh_code: selectedMesh.code,
    cuis: selectedCuisCodes
  };

  // Send a request to create records in pivot table...
  return dispatch('meshes/createMeshCui', meshCuiData).then(function (response) {
    // Prepare data for Actions
    var pivots = response.data.data.cuis.flatMap(function (o) {
      return o.pivot;
    });
    var filteredIds = pivots.filter(function (p) {
      return selectedCuisCodes.includes(p.cui_code);
    }).flatMap(function (r) {
      return r.id;
    });
    var actionData = {
      actionId: action.id,
      targetModelId: selectedMesh.id,
      tableModelIds: filteredIds,
      tableModel: 'mesh_cui',
      targetModel: 'mesh',
      details: JSON.stringify({
        mesh: selectedMesh.name
      })
    };

    // Send a request to create records in pivot table...
    return dispatch('conceptActions/applyAction', actionData, {
      root: true
    }).then(function () {
      // Reset selected MeSH
      commit('meshes/SET', {
        state: 'selectedMesh',
        data: null
      });
      // Reset selected Cuis
      commit('SET', {
        state: 'cuisSelection',
        data: []
      });
    });
  });
}

/**
 * Send API request for Detaching/Confirming Queries.
 *
 *
 * @param dispatch
 * @param commit
 * @param getters
 * @param rootGetters
 * @param {Object} payload
 * @param {string} payload.concept
 * @param {string} payload.content
 * @param {number} payload.flag
 * @param {string} [payload.actionLabel]
 * @param {string} [payload.secondaryActionName]
 * @param {boolean} [payload.all]
 * @returns {*}
 */
export function applyDetachConfirmAction(_ref31, payload) {
  var dispatch = _ref31.dispatch,
    commit = _ref31.commit,
    getters = _ref31.getters,
    rootGetters = _ref31.rootGetters;
  var confirmArray = getters['queriesSelection'].filter(function (q) {
    return q.action === 'confirm';
  });
  var detachArray = getters['queriesSelection'].filter(function (q) {
    return q.action === 'detach';
  });
  // Remove empty arrays
  var actionsArr = [confirmArray, detachArray].filter(function (arr) {
    return arr.length;
  });
  var data, action, secondaryAction;
  var selectedConcept = getters['selectedConcept'];
  var prefix = payload.content === 'query' ? '' : "".concat(payload.content, "-");
  if (payload.secondaryActionName) {
    secondaryAction = rootGetters['conceptActions/actionByName'](payload.secondaryActionName);
  }
  if (payload.all) {
    var _secondaryAction;
    // Handle confirm/detach all which can be called with an empty selection
    action = rootGetters['conceptActions/actionByName']("".concat(prefix).concat(payload.concept, "-").concat(payload.actionLabel));
    data = {
      actionId: action.id,
      tableModel: getters.concept + '_' + snakeCase(getters.content),
      tableModelIds: 'all',
      targetModel: getters['concept'],
      targetModelId: selectedConcept.id,
      details: JSON.stringify({
        term: selectedConcept.term,
        flag: payload.flag
      }),
      secondaryActionId: (_secondaryAction = secondaryAction) === null || _secondaryAction === void 0 ? void 0 : _secondaryAction.id
    };
    return dispatch('conceptActions/applyAction', data, {
      root: true
    }).then(function (response) {
      if (!payload.skipCommits) {
        commit('UPDATE_CONCEPT_QUERIES', response.data);
      }
    });
  } else {
    //  Handle passing something in selection
    actionsArr.forEach(function (arr) {
      action = rootGetters['conceptActions/actionByName']("".concat(prefix).concat(payload.concept, "-").concat(arr[0].action));
      if (!action) {
        throw new Error("Action is missing. Check db table \"actions\" for \"".concat(prefix).concat(payload.concept, "-").concat(arr[0].action, "\"."));
      }

      // Group items by flag
      var groupByFlagIds = groupArrayOfObjects(arr, 'flag');

      // Iterate through flags
      Object.keys(groupByFlagIds).forEach(function (flagId) {
        var _secondaryAction2;
        data = {
          actionId: action.id,
          tableModel: getters.concept + '_' + snakeCase(getters.content),
          tableModelIds: groupByFlagIds[flagId].map(function (cq) {
            return cq.id;
          }),
          targetModel: getters['concept'],
          targetModelId: selectedConcept.id,
          details: JSON.stringify({
            term: selectedConcept.term,
            flag: flagId
          }),
          secondaryActionId: (_secondaryAction2 = secondaryAction) === null || _secondaryAction2 === void 0 ? void 0 : _secondaryAction2.id
        };
        return dispatch('conceptActions/applyAction', data, {
          root: true
        }).then(function (response) {
          if (!payload.skipCommits) {
            commit('UPDATE_CONCEPT_QUERIES', response.data);
          }
        });
      });
    });
  }
}
export function getLinkedMeshes(_ref32) {
  var dispatch = _ref32.dispatch,
    commit = _ref32.commit;
  return dispatch('conceptActions/getAllActionsByName', 'CUIs linked to MeSH', {
    root: true
  }).then(function (response) {
    commit('SET_ARRAY', {
      state: 'linkedMeshes',
      data: response.data.data
    });
  });
}
export function selectDeselectDisplayed(_x, _x2) {
  return _selectDeselectDisplayed.apply(this, arguments);
}

/**
 * Updates item's flag in the store.
 * @param context
 * @param {Object} payload
 * @param {int} payload.itemId
 * @param {int} payload.flagId
 */
function _selectDeselectDisplayed() {
  _selectDeselectDisplayed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref33, payload) {
    var commit, getters, rootGetters, user, selection, nGrams, selected;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          commit = _ref33.commit, getters = _ref33.getters, rootGetters = _ref33.rootGetters;
          user = rootGetters['auth/user'];
          selection = getters[payload.state]; // Select unassigned or n-grams assigned to current user
          nGrams = getters['nGrams'].filter(function (item) {
            return !item.user || item.user.id === user.id;
          });
          selected = [];
          nGrams.forEach(function (item) {
            var foundIndex = selection.findIndex(function (i) {
              return i.id === item.id;
            });
            if (!payload.key && foundIndex === -1) {
              selected.push(item);
            } else if (payload.key && foundIndex >= 0) {
              selected.push(item);
            }
          });
          if (payload.key) {
            // Deselect displayed
            commit('TOGGLE_MANY_ARRAY', _objectSpread(_objectSpread({}, payload), {}, {
              data: selected
            }));
          } else {
            // Select displayed
            commit('PUSH_ARRAY', _objectSpread(_objectSpread({}, payload), {}, {
              data: selected
            }));
          }
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _selectDeselectDisplayed.apply(this, arguments);
}
export function updateItemFlag(_ref34, _ref35) {
  var commit = _ref34.commit;
  var itemId = _ref35.itemId,
    flagId = _ref35.flagId;
  commit('UPDATE_PROPERTY', {
    state: 'queriesSelection',
    targets: [{
      id: itemId
    }],
    prop: 'flag',
    value: flagId,
    key: 'id'
  });
}